module.exports = __webpack_public_path__ + "866d1bbae66af5664e2662dcff9599c6.svg";